import axios from 'axios';

export async function getRoundsLeague(league_pk) {
  try {
    const res = await axios({
      method: 'GET',
      url: process.env.REACT_APP_API_URL + `/api/league/leagues/${league_pk}/rounds/`,
    });
    const originalRounds = res.data;
    // @todo - this is a hot fix to fix the rounds order
    const sortedRounds = originalRounds.sort((a, b) => a.round_number - b.round_number);

    return { ...res, data: sortedRounds };
  } catch (error) {
    return { error: error };
  }
}

